import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {ProviderServiceModel} from "../../../api/entity/providerService.model";
import {ProviderServiceConverter} from "../../../api/entity/converter/providerService.converter";
import {AbstractDataServiceV2} from "../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {CustomizeHttpUrlGenerator} from "../../../../../../store/core/url/customizeHttpUrlGenerator";
@Injectable({
    providedIn: 'root'
})
export class ProviderServiceDataService extends AbstractDataServiceV2<ProviderServiceModel, ProviderServiceConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
                converter: ProviderServiceConverter) {
        super('ProviderService', http, httpUrlGenerator, logger, config, converter);
    }
}
